import { z } from 'zod'

import { OFFICIAL_REPORT_FORM_FIELDS } from './constant'
import { LateTimeType } from '@/types/officialReport'

export const timePattern = /^(?:[01]\d|2[0-3]):[0-5]\d$/
const datePattern = /^(?:0[1-9]|[12]\d|3[01])\/(?:0[1-9]|1[0-2])\/\d{4}$/

export const commonSchema = z.object({
    [OFFICIAL_REPORT_FORM_FIELDS.dateOfIssue]: z
        .string()
        .regex(datePattern, 'Invalid date. Please use the format DD/MM/YYYY (e.g., 14/04/2025).')
        .optional(),
    [OFFICIAL_REPORT_FORM_FIELDS.driverEmployeeNumber]: z.string().optional(),
    [OFFICIAL_REPORT_FORM_FIELDS.locationOfIssue]: z.string().max(200).min(1).optional(),
    [OFFICIAL_REPORT_FORM_FIELDS.details]: z.string().optional(),
    [OFFICIAL_REPORT_FORM_FIELDS.driverStatement]: z.string().optional(),
})

export const mileageLossSchema = z.object({
    [OFFICIAL_REPORT_FORM_FIELDS.timeOfIssue]: z
        .string()
        .regex(timePattern, 'Invalid time. Please use the 24-hour format HH:MM (e.g., 14:30).'),
})

export const lateSchema = z.object({
    [OFFICIAL_REPORT_FORM_FIELDS.timeType]: z.nativeEnum(LateTimeType).optional(),
    [OFFICIAL_REPORT_FORM_FIELDS.takeoverTime]: z
        .string()
        .regex(timePattern, 'Invalid time. Please use the 24-hour format HH:MM (e.g., 14:30).')
        .optional(),
    [OFFICIAL_REPORT_FORM_FIELDS.actualTakeoverTime]: z
        .string()
        .regex(timePattern, 'Invalid time. Please use the 24-hour format HH:MM (e.g., 14:30).')
        .optional(),
})

export const headwaySchema = z.object({
    [OFFICIAL_REPORT_FORM_FIELDS.headways]: z
        .object({
            headway: z.string().optional(),
            busStop: z.string().optional(),
            observedAt: z.string().optional(),
        })
        .array(),
})

export type FormValuesType = z.infer<
    typeof commonSchema & typeof mileageLossSchema & typeof lateSchema & typeof headwaySchema
>
